import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEraser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEraser"><Path fillRule="evenodd" clipRule="evenodd" d="M14.5001 1.43933L22.5546 9.49379L11.316 21H7.93945L1.43945 14.5L14.5001 1.43933ZM3.56077 14.5L8.56077 19.5H10.6843L12.5398 17.6003L6.50011 11.5607L3.56077 14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEraser;
